import styled from "styled-components";
import useBoard from "../../hooks/inquiry/useBoard";
import BoardItem from "../../components/inquiry/BoardItem";
import useComparePassword from "../../hooks/inquiry/useComparePassword";
import InputModal from "../../components/common/InputModal";
import Modal from "../../components/common/Modal";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import { useNavigate } from "react-router-dom";

function Board(){
    const navigate = useNavigate();
    const {boardList,category, onSelectChangeHandler} = useBoard()
    const {input, onChange, showPasswordModal, setShowPasswordModal, showErrorModal, setShowErrorModal, onComparePasswordHandler, onConfirmClick} = useComparePassword();
    const getBoardList = () => {
        if(!boardList.length){
            return null;
        }
        return boardList.map((item, index) => {
            return <BoardItem key={index} isSecret={item.isSecret} content={item.isSecret ? "비밀글 입니다" : item.content} category={item.category} writer={item.company} registerAt={item.register_at} id={item.id} onComparePasswordHandler={onComparePasswordHandler}/>
        })
    }
    return(
        <Container>
            <InputModal isOpen={showPasswordModal} onConfirm={onConfirmClick} onClose={() => setShowPasswordModal(false)} title={"비밀번호를 입력해 주세요"} value={input} onChange={onChange} placeholder={"비밀번호"}/>
            <Modal isOpen={showErrorModal} onClose={() => setShowErrorModal(false)} title={"ERROR"} content={"비밀번호가 잘못되었습니다"}/>
            <Header />
            <div className="inner">
                <Contents>
                    <BoardHeader>
                        <Label>FAQ</Label>
                        <Select name="category" onChange={onSelectChangeHandler} defaultValue={category}>
                            <Option value={"전체"}>전체</Option>
                            <Option value={"계정"}>계정</Option>
                            <Option value={"결제"}>결제</Option>
                            <Option value={"주문/배송"}>주문/배송</Option>
                            <Option value={"기타"}>기타</Option>
                        </Select>
                    </BoardHeader>
                    <Table>
                        <tbody>
                            <TrHead><TdHead style={{textAlign:"center"}}></TdHead><TdHead ></TdHead><TdHead style={{textAlign:"center"}}></TdHead><TdHead style={{textAlign:"center"}}></TdHead><TdHead></TdHead></TrHead>
                            {getBoardList()}
                        </tbody>
                    </Table>
                    <ButtonWrite onClick={() => navigate("/inquiry")}>글쓰기</ButtonWrite>
                </Contents>
            </div>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-top: 180px;
`

const BoardHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

const Select = styled.select`
`

const Option = styled.option`
`

const Label = styled.div`
    color: #58AC65;
    font-size: 24px;
    font-weight: 700;
`

const Table = styled.table`
    width: 100%;
    border-collapse: collapse; 
`

const TrHead = styled.tr`
    border-bottom: 2px solid #007912;
`

const TdHead = styled.td`
    padding: 8px;
    font-size: 14px;
    color: #434343;
`

const ButtonWrite = styled.button`
    margin-top: 12px;
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    border-radius: 30px;
    background-color: #007912;
    border: none;
    padding: 12px;
    width: 120px;
    cursor: pointer;
    align-self: self-end;
`



export default Board;